import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Operator, OperatorFunction, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
  }

  public handleHttpError(error: HttpErrorResponse, defaultMessageKey: string = 'An error happened', useErrorMessageFromResponse = true): void {
    console.error(error);
    const errorMessage = (useErrorMessageFromResponse && error.error && error.error.message) || this.translate.instant(defaultMessageKey);
    this.toastr.error(errorMessage);
  }

  public rethrowHttpError(error: HttpErrorResponse|string, defaultMessageKey: string, useErrorMessageFromResponse = true): Observable<never> {
    console.error(error);
    let errorMessage: string;

    if (error instanceof HttpErrorResponse) {
      errorMessage = (useErrorMessageFromResponse && error.error && error.error.message) || this.translate.instant(defaultMessageKey);
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else {
      errorMessage = this.translate.instant(defaultMessageKey)
    }

    this.toastr.error(errorMessage);
    return throwError(errorMessage);
  }
}
